import { render, staticRenderFns } from "./LegacyAttributesView.vue?vue&type=template&id=0f1aadd2&scoped=true&"
import script from "./LegacyAttributesView.vue?vue&type=script&lang=js&"
export * from "./LegacyAttributesView.vue?vue&type=script&lang=js&"
import style0 from "./LegacyAttributesView.vue?vue&type=style&index=0&id=0f1aadd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1aadd2",
  null
  
)

export default component.exports